module.exports = __webpack_public_path__ + "7b28f1d82de640ac764db64d74ef8fec.svg";